import PropTypes from 'prop-types';
import { numberFormat } from '@/utils/unitUtils';

const toNumber = amount => {
  if (amount == null) return null;
  if (typeof amount?.toNumber === 'function') return amount.toNumber();
  return Number(amount);
};

const Tile = ({ label, row, emphasize }) => {
  const value = row ? toNumber(row.amount) : null;
  return (
    <div className="flex flex-col gap-0.5 py-2">
      <div className="text-xs text-gray-500">{label}</div>
      <div className="flex items-baseline gap-1">
        <span
          className={`tabular-nums ${emphasize ? 'text-2xl font-semibold text-gray-900' : 'text-base font-medium text-gray-800'}`}
        >
          {value == null ? '—' : numberFormat(value, emphasize ? 0 : 2)}
        </span>
        {row?.unit && <span className="text-xs text-gray-500">{row.unit}</span>}
      </div>
    </div>
  );
};

Tile.propTypes = {
  label: PropTypes.string.isRequired,
  row: PropTypes.object,
  emphasize: PropTypes.bool,
};

const findByLabel = (items, label) => items?.find(item => item.label === label);

const AbsoluteCosts = ({ totalCosts }) => {
  if (!totalCosts || totalCosts.length === 0) {
    return null;
  }

  const capital = findByLabel(totalCosts, 'Capital Cost');
  const fixedOpex = findByLabel(totalCosts, 'Fixed Operating Cost');
  const variableOpex = findByLabel(totalCosts, 'Variable Operating Cost');
  const fixedMaintenance = findByLabel(totalCosts, 'Fixed Maintenance Cost');
  const scheduledMaintenance = findByLabel(totalCosts, 'Scheduled Maintenance Cost');

  // Feedstock and utility costs are shown in their own dedicated breakdown
  // table, so they're intentionally excluded here.
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-x-8">
      <Tile label="Capital cost" row={capital} emphasize />
      <Tile label="Fixed operating" row={fixedOpex} />
      <Tile label="Variable operating" row={variableOpex} />
      <Tile label="Fixed maintenance" row={fixedMaintenance} />
      <Tile label="Scheduled maintenance" row={scheduledMaintenance} />
    </div>
  );
};

AbsoluteCosts.propTypes = {
  totalCosts: PropTypes.array,
};

export default AbsoluteCosts;
